import { jsx as _jsx } from "react/jsx-runtime";
import { Link } from 'react-router-dom';
import clsx from 'clsx';
import classes from '../GridTable.module.css';
export const Row = ({ children, className, type, to, onClick, 'data-tid': dataTid }) => {
    const shouldHover = type === 'hover' || to !== undefined || onClick !== undefined;
    const hasPointer = to !== undefined || onClick !== undefined;
    const rowClasses = clsx(classes.row, className, shouldHover && classes.hover, hasPointer && classes.pointer, type === 'selected' && classes.selected, type === 'header' && classes.header);
    const props = {
        onClick,
        className: rowClasses,
        'data-tid': dataTid,
    };
    if (to !== undefined) {
        return (_jsx(Link, { to: to, ...props, children: children }));
    }
    return _jsx("div", { ...props, children: children });
};
